import { twMerge } from '@sortlist-frontend/design-system';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import Image from 'next/image';

import { rankingConfig } from '../ranking.config';

interface AgencyLogoProps {
  src: string;
  name: string;
  size?: 'sm' | 'md';
}

export const AgencyLogo = (props: AgencyLogoProps) => {
  const { src, name, size = 'md' } = props;
  const { t } = useTranslation(rankingConfig.i18nNamespaces);
  const pixels = size === 'md' ? 64 : 48;

  return (
    <Image
      src={src}
      width={pixels}
      height={pixels}
      alt={t('longtail:ranking.agency.logoAlt', { name })}
      loading="lazy"
      unoptimized
      className={twMerge(
        'shrink-0 rounded-xl border border-secondary-200 bg-white object-contain',
        size === 'md' ? 'h-14 w-14 md:h-16 md:w-16' : 'h-12 w-12',
      )}
    />
  );
};
